<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" :inline="true" class="bg-white p-1">
      <el-form-item label="部门名称" prop="deptName">
        <el-input
            v-model="queryParams.query.deptName"
            placeholder="请输入部门名称"
            clearable
            size="small"
            @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8 my-1">
      <el-col :span="1.5">
        <el-button
            type="primary"
            icon="el-icon-plus"
            size="mini"
            @click="handleAdd"
            v-hasPermi="['system:dept:add']"
        >新增
        </el-button>
      </el-col>
    </el-row>

    <el-table
        v-loading="loading"
        :data="deptList"
        row-key="id"
        default-expand-all
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        :header-cell-style="{background: '#DDD'}"
    >
      <el-table-column prop="deptName" label="部门名称" min-width="280"></el-table-column>
      <el-table-column prop="code" label="部门编码" width="140"></el-table-column>
      <!-- <el-table-column prop="level" label="部门等级" width="120">
          <template v-slot="scope">
              {{getLevelName(scope.row.level)}}
          </template>
      </el-table-column> -->
      <el-table-column label="部门类型" align="center" prop="typeCode" width="120">
        <template v-slot="scope">
          {{getUserTypeName(scope.row.typeCode)}}
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序" width="80"></el-table-column>
      <el-table-column label="创建时间" align="center" prop="createTime" width="180">
        <template v-slot="scope">
          <span>{{ parseTime(scope.row.createTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="180" class-name="small-padding fixed-width">
        <template v-slot="scope">
          <el-button
              size="mini"
              type="text"
              icon="el-icon-edit"
              @click="handleUpdate(scope.row)"
              v-hasPermi="['system:dept:edit']"
          >修改
          </el-button>
          <el-button
              size="mini"
              type="text"
              icon="el-icon-plus"
              @click="handleAdd(scope.row)"
              v-hasPermi="['system:dept:add']"
          >新增
          </el-button>
          <el-button
              v-if="scope.row.parentId != 0"
              size="mini"
              type="text"
              icon="el-icon-delete"
              @click="handleDelete(scope.row)"
              v-hasPermi="['system:dept:remove']"
          >删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
        v-show="total>0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
    />

    <!-- 添加或修改部门对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="620px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-row>
          <el-col :span="24" v-if="form.parentId !== 0">
            <el-form-item label="上级部门" prop="parentId">
              <treeselect :disabled="treeselectDisabled" v-model="form.parentId" :options="deptOptions" :normalizer="normalizer" placeholder="选择上级部门"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="部门名称" prop="deptName">
              <el-input v-model="form.deptName" placeholder="请输入部门名称"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="显示排序" prop="orderNum">
              <el-input-number v-model="form.sort" controls-position="right" :min="0"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="部门编号" prop="code">
              <el-input v-model="form.code" placeholder="请输入部门编号"/>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="部门等级" prop="level">
              <el-select v-model="form.level" placeholder="请选择">
                <el-option
                    v-for="item in levelData"
                    :key="item.dictValue"
                    :label="item.dictLabel"
                    :value="item.dictValue"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <!-- <el-col :span="12">
            <el-form-item label="角色" prop="roleIds">
              <el-select v-model="form.roleIds" multiple placeholder="请选择角色">
                <el-option
                    v-for="item in roleOptions"
                    :key="item.id"
                    :label="item.roleName"
                    :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="部门类型" prop="typeCode">
              <el-select v-model="form.typeCode" placeholder="请选择部门类型">
                <el-option
                    v-for="item in deptTypeOptions"
                    :key="item.dictValue"
                    :label="item.dictLabel"
                    :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>

    </el-dialog>
  </div>
</template>

<script>
import {deptPage, deptTree, deptDetail, deptAdd, deptUpdate, deptDelete, deptListExclude} from "@/api/sys/dept";
import Treeselect from "@riophae/vue-treeselect";
import {roleList} from "@/api/sys/role";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import {uploadFile} from "@/api/upload/upload.js";
import Pagination from "@/components/Pagination";
export default {
  name: "Dept",
  components: {Treeselect, Pagination},
  data() {
    return {
      //部门类型
      deptTypeOptions:[],
      //角色选项
      roleOptions:[],
      //部门类型
      levelData:[],
      // 遮罩层
      loading: true,
      // 显示搜索条件
      showSearch: true,
      // 表格树数据
      deptList: [],
      // 总条数
      total: 0,
      // 部门树选项
      deptOptions: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        query: {
          deptName: undefined,
          status: undefined
        }
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        parentId: [
          {required: true, message: "上级部门不能为空", trigger: "blur"}
        ],
        deptName: [
          {required: true, message: "部门名称不能为空", trigger: "blur"}
        ],
        sort: [
          {required: true, message: "显示排序不能为空", trigger: "blur"}
        ],
        code: [
          {required: true, message: "部门编号不能为空", trigger: "blur"}
        ],
        typeCode: [
          {required: true, message: "部门类型不能为空", trigger: "blur"}
        ],
        roleIds: [
          {required: true, message: "角色不能为空", trigger: "change", type: "array", min: 1}
        ],
        // contactPhone: [
        //   {required: true, message: "联系电话不能为空", trigger: "blur"}
        // ],
        // level: [
        //   {required: true, message: "请选择等级", trigger: "blur"}
        // ],
      },
      treeselectDisabled:false,
      /*levelData:[
        {key:"SJ",name:"市局",disabled:false},
        {key:"QJ",name:"区级",disabled:false},
        {key:"X",name:"乡",disabled:false},
        {key:"JDZ",name:"街道镇",disabled:false},
        {key:"SQ",name:"社区",disabled:false},
        {key:"WG",name:"网格",disabled:false},
      ]*/
    };
  },
  created() {
    this.getList();
     //部门类型
     this.getDicts("sys_dept_type").then((res) => {
      this.deptTypeOptions = res.data;
    })
    //部门类型
    this.getDicts("zzjg_bmlx").then((res) => {
      this.levelData = res.data;
    })
  },
  methods: {
    //列表部门类型回显
    getUserTypeName(type){
      return this.selectDictLabel(this.deptTypeOptions, String(type));
    },
      //列表部门等级回显
     getLevelName(type){
         return this.selectDictLabel(this.levelData, String(type));
     },
    // logo
    logUpload({file}) {
      const that = this;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("type", "app-logo");
      uploadFile(formData).then((res) => {
        if (res.code === 200) {
          that.form.logoUrl = res.data.url;
        }
      });
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/jpg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 1;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG JPEG PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 1MB!");
      }
      return isJPG && isLt2M;
    },
    /** 查询部门列表 */
    getList() {
      this.loading = true;
      deptPage(this.queryParams).then(response => {
        // 分页API返回格式通常是 {data: {rows: [], total: number}} 或 {data: [], total: number}
        if (response.data && response.data.rows) {
          this.deptList = this.handleTree(response.data.rows, "id");
          this.total = response.data.total || 0;
        } else if (Array.isArray(response.data)) {
          this.deptList = this.handleTree(response.data, "id");
          this.total = response.total || response.data.length || 0;
        } else {
          this.deptList = this.handleTree(response.data, "id");
          this.total = 0;
        }
        this.loading = false;
      });
    },
    /** 获取角色列表 */
    getRoleList() {
      roleList({}).then(response => {
        this.roleOptions = response.data;
      });
    },
    /** 转换部门数据结构 */
    normalizer(node) {
      if (node.children && !node.children.length) {
        delete node.children;
      }
      return {
        id: node.id,
        label: node.deptName,
        children: node.children
      };
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.resetForm("form");
      this.form = {
        id: undefined,
        parentId: undefined,
        query: {
          deptName: undefined,
          status: undefined
        },
        sort: 1,
        code: undefined,
        typeCode: undefined,
        roleIds: []
      };
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.queryParams.query.deptName = undefined;
      this.queryParams.query.status = undefined;
      this.handleQuery();
    },
    /** 新增按钮操作 */
    handleAdd(row) {
  /*    this.levelData[0].disabled=false;
      this.levelData[1].disabled=false;
      this.levelData[2].disabled=false;
      this.levelData[3].disabled=false;
      this.levelData[4].disabled=false;
      this.levelData[5].disabled=false;*/
      this.treeselectDisabled = false;
      this.reset();
      if (row.id !== undefined) {
        this.treeselectDisabled = true;
        this.form.parentId = row.id;
      }
      this.getRoleList();
      this.open = true;
      this.title = "添加部门";
      // 下拉选择使用树形结构API，不需要分页
      deptTree({}).then(response => {
        this.deptOptions = [];
        const dept = { id: "0", deptName: '主类目', children: [] };
        dept.children = this.handleTree(response.data, "id");
        this.deptOptions.push(dept);
      });
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      this.treeselectDisabled = false;
      this.getRoleList();
      deptDetail(row.id).then(response => {
        this.form = response.data;
        this.form.typeCode = String(response.data.typeCode);
        this.form.roleIds = response.data.roleIds || [];
        this.open = true;
        this.title = "修改部门";
      });
      deptListExclude(row.id).then(response => {
        this.deptOptions = [];
        const dept = { id: "0", deptName: '主类目', children: [] };
        dept.children = this.handleTree(response.data, "id");
        this.deptOptions.push(dept);
      });
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs["form"].validate(valid => {
        if (valid) {
          // 根据 typeCode 获取对应的 typeName
          const typeOption = this.deptTypeOptions.find(item => item.dictValue === this.form.typeCode);
          const submitData = {
            ...this.form,
            typeName: typeOption ? typeOption.dictLabel : ''
          };
          
          if (this.form.id !== undefined) {
            deptUpdate(submitData).then(() => {
              this.msgSuccess("修改成功");
              this.open = false;
              this.getList();
            });
          } else {
            deptAdd(submitData).then(() => {
              this.msgSuccess("新增成功");
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      this.$confirm('是否确认删除名称为"' + row.deptName + '"的数据项?', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return deptDelete(row.id);
      }).then(() => {
        this.getList();
        this.msgSuccess("删除成功");
      })
    }
  }
};
</script>
<style  scoped>
::v-deep .el-upload {
  border: none;
}

::v-deep .el-form-item-content, ::v-deep .el-cascader {
  width: 330px;
}

::v-deep .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 146px;
  height: 146px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 146px;
  height: 146px;
  line-height: 146px;
  text-align: center;
}

.bgitem {
  display: flex;
  flex-wrap: wrap;
}

.bgitem .item {
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  align-items: center;
  margin-right: 5px;
  cursor: pointer;
}

.bgitem .item img {
  width: 146px;
  height: 146px;
}

.avatar {
  width: 148px;
  height: 148px;
  display: block;
  object-fit: fill;
}

.el-select {
  width: 100%;
}

.el-date-editor.el-input {
  width: 100% !important;
}
</style>
